








































import Vue from 'vue';

export default Vue.extend({
    methods: {
        jump(name) {
            if (name === '/about-manufacturer' && this.$route.name === 'AboutManufacturer') return;
            if (name === '/about' && this.$route.name === 'About') return;
            this.$router.push({
                path: name,
            });
        },
    },
});
